import { COOKIE_RESPONSIBLE_URL, TERMS_OF_USE_COOKIES_EXPIRATION_TIMEOUT } from './constants'

export const getShouldRedirectFromCookies = () => {
  const r = document.cookie.match(`\\b${COOKIE_RESPONSIBLE_URL}=([^;]*)\\b`)
  return r ? r[1] : undefined
}

export const clearShouldRedirectFromCookies = () => {
  document.cookie = `${COOKIE_RESPONSIBLE_URL}="";path=/;domain=.plurall.net;expires=Thu, 01 Jan 1970 00:00:00 GMT`
}

export const setCookie = (
  name,
  value,
  minutesToExpire = TERMS_OF_USE_COOKIES_EXPIRATION_TIMEOUT,
) => {
  const date = new Date()
  date.setTime(date.getTime() + minutesToExpire)
  const expires = `expires=${date.toUTCString()}`
  const encodedValue = encodeURIComponent(value)
  document.cookie = `${name}=${encodedValue}; ${expires}; path=/; domain=.plurall.net;`
}
